import { IRestApiService } from '../types';

export interface TalkenSetupPayload {
    clientId: string;
    clientSecret: string;
}

export interface TalkenSyncClientPayload {
    clientId: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    email?: string;
    birthday?: string;
    force?: boolean;
}

export interface TalkenClientConflict {
    id: number;
    externalId: string;
    schoolId: number;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    mobileNumber2?: string;
    birthday?: string;
    email?: string;
    comment_for_teacher?: string;
    comment_for_student?: string;
}

export type TalkenSyncClientResponse =
    | { ok: true; data: { status: 'created' | 'updated' | 'matched'; client?: { id: string } } }
    | { ok: false; error: { type: 'conflict'; client: TalkenClientConflict } | { type: 'validation'; details: unknown } | { type: 'http'; status: number } };

class IntegrationsApiCall {
    private restApiService: IRestApiService;

    constructor(restApiService: IRestApiService) {
        this.restApiService = restApiService;
    }

    setupTalken(payload: TalkenSetupPayload): Promise<{ ok: boolean; error?: string; talken?: { clientId: string; clientSecretMasked: string } }> {
        return this.restApiService.post('integrations/talken/setup', payload);
    }

    removeTalken(): Promise<{ ok: boolean; error?: string }> {
        return this.restApiService.post('integrations/talken/remove', {});
    }

    testTalken(payload?: { clientId?: string; clientSecret?: string }): Promise<{ ok: boolean; error?: string }> {
        return this.restApiService.post('integrations/talken/test', payload ?? {});
    }

    syncTalkenClient(payload: TalkenSyncClientPayload): Promise<TalkenSyncClientResponse> {
        return this.restApiService.post('integrations/talken/sync-client', payload);
    }

    getTalkenSettings(): Promise<{ ok: boolean; talkenBaseUrl: string }> {
        return this.restApiService.get('integrations/talken/settings');
    }
}

export default IntegrationsApiCall;